import { render } from "./TasksResource.vue?vue&type=template&id=154d0eee"
import script from "./TasksResource.vue?vue&type=script&lang=js"
export * from "./TasksResource.vue?vue&type=script&lang=js"
script.render = render

export default script